import { Tag } from 'antd';
import FilterInput from "components/Form/filterInput";
import { useCallback,useEffect,useState } from "react";


import { format } from "date-fns";
import { useSearchParams } from 'react-router-dom';
import { toTitleCase } from "utils/common";


import { Button } from "components/Button";


const AssetListFilter = ({handleFilterDrawer, filters, handleInputChange, searchPlaceholder, handleFilterChange, loading}) => {
 

const [searchParams, setSearchParams] = useSearchParams();

  const [appliedFilters, setAppliedFilters] = useState([])


  const setInputValue = useCallback((key) => {

   console.log(filters, "---filters in setinputvalueeeeeee")
    if(filters.length){
      let selectedValue = [...filters].find(item=> item.key === key)
      return selectedValue?.value
    }else{
      return ""
    }
  
  }, [filters]);

    useEffect(()=>{
   
      let _appliedFilters = [...filters].map(item=>{
        let label = ""
        let value = ""
        switch(item.key){
          case "issued_date_after":
            let date = toTitleCase(searchParams.get("issued_date_after") || "")
            let date_formatted = ""
            if(date){
              date_formatted = format(searchParams.get("issued_date_after"), "yyyy-MM-dd")
            }
            value = date_formatted
            label = "Issued After"
            break;
          case "issued_date_before":
            let date_before = toTitleCase(searchParams.get("issued_date_before") || "")
            let date_formatted_before = ""
            if(date_before){
              date_formatted_before = format(searchParams.get("issued_date_before"), "yyyy-MM-dd")
            }
            value = date_formatted_before
            label = "Issued Before"
            break;

            case "returned_date_after":
              let date_returned_after = toTitleCase(searchParams.get("returned_date_after") || "")
              let date_formatted_return_after = ""
              if(date_returned_after){
                date_formatted_return_after = format(searchParams.get("returned_date_after"), "yyyy-MM-dd")
              }
              value = date_formatted_return_after
              label = "Returned After"
              break;
            case "returned_date_before":
              let date_returned_before = toTitleCase(searchParams.get("returned_date_before") || "")
              let date_formatted_return_before = ""
              if(date_returned_before){
                date_formatted_return_before = format(searchParams.get("returned_date_before"), "yyyy-MM-dd")
              }
              value = date_formatted_return_before
              label = "Returned Before"
              break;
          
            case "search":
              value = toTitleCase(searchParams.get("search") || "")
              label = "Search term"
              break;
          
          default:
            label = ""
            value = ""
        }
        return {
          ...item,
          value,
          label
        }
      })
      setAppliedFilters(_appliedFilters.filter(item=> item.value && item.key != "search"))

  
  

 
  },[   
    searchParams
  ])


  const handleClose = (e, item) => {
    console.log(item, "llll")
    e.preventDefault();
    if(item.key == "search" || item.key == "issued_date_after" || item.key == "issued_date_before" || item.key == "returned_date_before" || item.key == "returned_date_after"){
      handleInputChange("", item.key, true)
    }else{
      handleFilterChange("", item.key, true)
    }
  }
  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-10">
        <div className="row" >
        <div className='col-sm-12 col-lg-4  ' >
        <FilterInput  
         defaultValue={setInputValue("search")} 
         onChange={e=>{handleInputChange(e.target.value, "search", true)}} 
          id="search"
           label={searchPlaceholder}
            />
        </div>
        <div className='col-sm-12  col-lg-8  mt-1 flex-wrap' >
          
        {
            appliedFilters.map(item=>{
              return (
                <Tag icon={loading&&<i class="fas fa-spinner fa-spin me-1" aria-hidden="true"></i>} className="mb-1" color={"red"} closable closeIcon={<i class="fa fa-times" aria-hidden="true"></i>} onClose={e=>handleClose(e, item)}>
                  {
                    item?.label
                  }
                  {item.label && " : "}
                  {item?.value}
                </Tag>
              )
            })
          }

        </div>

          </div>
        
      
        </div>
      
 
        <div className="col-2 d-flex justify-content-end" style={{ paddingRight: 0 }}>
        <div className="view-icons">
        <Button onClick={handleFilterDrawer} icon="las la-filter" id="collapse-header" className="list-view btn btn-link "/>
        </div>
       
        </div>
      </div>
    </div>
  );
};

export default AssetListFilter;
